import React, { useRef, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import "./addReport.scss";
import SwCommonForm from "./addReport/swCommonForm";
import AddIcon from "@mui/icons-material/Add";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioGroup from "@mui/material/RadioGroup";
import RadioButton from "../../../../library/custom/radioButton/RadioButton";
import FormControl from "@mui/material/FormControl";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import Buttons from "../../../../library/custom/button/Button";
import PreviousOpenItems from "./addReport/previousOpenItems";
import { InputField } from "../../../../library/custom/textBox/InputField";
import TextEditor from "../../../../library/custom/textEditor/TextEditor";
import commonImages from "../../../../assets";
import SwIndividualCommonForm from "./addReport/swIndividualCommonForm";
import Loader from "../../../../library/common/Loader";
import NorthCarolina from "./addReport/northCarolina";
import ThreeQuestion from "./addReport/threeQuestion";
import { useThemeContext } from "../../../../context";
import Checkbox from "../../../../library/checkbox/checkbox";
import { SIGNOFF_METHOD_TYPE, YES_NO } from "../../../../constant/constant";
import { CURRENT_PHASE_STATUS } from "../../../../constant/storm-water/constant";
import SouthCarolina from "./addReport/southCarolina";

const AddReport = ({
  questionSetId,
  swQuestionSetDetail,
  getInTyFeByInTyList,
  handleRadioType,
  formchangeHnadle,
  formValue,
  setFormValue,
  submitData,
  deleteform,
  saveData,
  contractorsignatureUpload,
  selectedContractorSignature,
  signatureError,
  deleteHandler,
  isProjectName,
  isCustomerName,
  isProjectNo,
  isPrimaryInspector,
  isDateofInspection,
  isTimeofInspection,
  isWeatherAtTimeofInspection,
  isSoilTypeId,
  isStageOfConstruction,
  isSampleTaken,
  isPrimaryPermitteeName,
  isCurrentApproximateDisturbedAcreage,
  isNPDESTrackingNumber,
  getOpenItem,
  openItemHandler,
  previousItem,
  getSwReference,
  isSignatureProfile,
  hiddenAttendeeSignatureInput,
  addMediaNotAccUpload,
  setImageCheck,
  listPermitte,
  mapId,
  handleAllProjectSearch,
  isProjectLoading,
  allProjects,
  onChangeProjects,
  projects,
  inspectionQuestionSetList,
  inspectionTypeId,
  handleInspectionTypeSetChange,
  handleQuestionSetChange,
  allClients,
  clients,
  searchClient,
  onChangeClients,
  isSearchClientLoading,
  firstClientError,
  userInfo,
  inspectionHeaderDetails,
  constructionActivityId,
  handleConstructionActivitySetChange,
  isConstructionActivityId,
  frequencyValue,
  handleFrequencyChange,
  isMediaAllowed,
  isGeorgiaState,
  projectStatus,
  setProjectStatus,
  alsoSubmitRoutineInspection,
  handleChangeDefault,
  characterLimit,
  reportId,
  isRainFallError,
  isDirectIns,
  editMode,
  isFluid,
  frequencyInDays,
  dateRangeHandler,
  dateRangeError,
  errorFrequencyInDays,
  fileError,
  signaureFileError,
  signaureFileErrorMessage,
  isNorthCarolina,
  swInspectionConfQuestionAns,
  setSwInspectionConfQuestionAns,
  swRainFallData,
  swInspectionRainfallData,
  setSwInspectionRainfallData,
  swInspectionCurrentProjectPhase,
  setSwInspectionCurrentProjectPhase,
  swInspectionGroundStabilization,
  setSwInspectionGroundStabilization,
  swInspectionObservation,
  setSwInspectionObservation,
  swInspectionLotDisturbance,
  setSwInspectionLotDisturbance,
  setSwInspectionNewOrRevisedMeasures,
  swInspectionNewOrRevisedMeasures,
  // formchangeThreeHnadle,
  frequencyValueError,
  disabledCheck,
  insStatus,
  weather,
  swRainFallDataModalData,
  twoQuestionError,
  projectPhaseError,
  isProjectStatus,
  isRainfallChecked,
  isSiteAssessment,
  isTnpeNumber,
  isCpescNumber,
  isTennessee,
  setSwInspectionSiteCompliance,
  swInspectionSiteCompliance,
  signoffMethodValue,
  certifyStatementIdValue,
  acknowledgement,
  setAcknowledgement,
  isSouthCarolina,
  swInspectionNPDES,
  setSwInspectionNPDES,
  siteComplianceError
}) => {
  const { mode } = useThemeContext();
  const hiddenSignatureInput = useRef(null);
  const [accordionLoader, setaccordionLoader] = useState(false);
  const [allExpanded, setallExpanded] = useState(false);
  const [frequency, setFrequency] = useState();

  // temporary base change
  const [InspectionType, setInspectionType] = useState();


  useEffect(() => {
    if (isGeorgiaState && getSwReference?.insfrequencyList) {
      const newFrequency = getSwReference?.insfrequencyList?.filter(
        (item) => item.key !== 1
      );
      setFrequency(newFrequency);

      // temporary base change
      const newInspectionType = getSwReference?.insTypeMstList?.filter(
        (item) => item.key !== 2
      );
      setInspectionType(newInspectionType);
    } else {
      setFrequency(getSwReference?.insfrequencyList);

      // temporary base change
      setInspectionType(getSwReference?.insTypeMstList);
    }
  }, [isGeorgiaState, getSwReference?.insfrequencyList]);

  useEffect(() => {
    if (isFluid && getSwReference?.insfrequencyList) {
      const data = getSwReference?.insfrequencyList?.filter(
        (item) => item.key !== 1
      );
      setFrequency(data);
    } else {
      const data = getSwReference?.insfrequencyList?.filter(
        (item) => item.key !== 7
      );
      setFrequency(data);
    }
  }, [isFluid, getSwReference?.insfrequencyList]);

  const [expandedItems, setExpandedItems] = useState([]);
  function handleAccordionExpand(index) {
    setExpandedItems((prevExpanded) => {
      if (prevExpanded.includes(index)) {
        return prevExpanded?.filter((item) => item !== index);
      } else {
        return [...prevExpanded, index];
      }
    });
  }

  const rainFallHandler = (value, insRainFallData) => {
    const confRainFallValue = value;

    setSwInspectionRainfallData((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) => item.precipDateFormat === insRainFallData.precipDateFormat
      );
      if (existingIndex !== -1) {
        const updatedData = [...prevState];
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          day: insRainFallData?.precipDateFormat,
          rainfallAmt: insRainFallData?.evenTrackPrecipAmt,
          notes: confRainFallValue,
        };
        return updatedData;
      }
    });
  };
  const initials = formValue?.primaryInspector
    ? formValue?.primaryInspector
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase())
      ?.join("")
    : "";

  const projectPhaseHandler = (
    isChecked,
    statusValue,
    commentValue,
    projectPhaseData
  ) => {
    const updatedStatus = statusValue !== null ? statusValue : 0;

    setSwInspectionCurrentProjectPhase((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) =>
          (item.key || item.optionId) ===
          (projectPhaseData.key || projectPhaseData.optionId)
      );

      if (existingIndex !== -1) {
        const updatedData = [...prevState];
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          optionId: projectPhaseData?.key,
          isChecked: isChecked,
          comment: commentValue || "",
          status: updatedStatus,
        };
        return updatedData;
      }

      return prevState;
    });
  };

  const [projectPhaseAnyChecked, setProjectPhaseAnyChecked] = useState(false);

  useEffect(() => {
    if (swInspectionCurrentProjectPhase) {
      const anyChecked = swInspectionCurrentProjectPhase.some(
        (item) => item.isChecked
      );
      setProjectPhaseAnyChecked(anyChecked);
    }
  }, [swInspectionCurrentProjectPhase]);

  const twoQuesHandler = (value, insCQ) => {
    const confAns = value;
    setSwInspectionConfQuestionAns((prevState) => {
      const existingQuestion = prevState.find(
        (item) => item.confQuesId === insCQ.key
      );
      if (existingQuestion) {
        return prevState.map((item) =>
          item.confQuesId === insCQ.key ? { ...item, confAns: confAns } : item
        );
      } else {
        return [
          ...prevState,
          {
            confQuesId: insCQ.key,
            confAns: confAns,
          },
        ];
      }
    });
  };

  const allQuestionsAnswered = getSwReference?.InsConfQuesList?.slice(
    2,
    4
  )?.every((insCQ) =>
    swInspectionConfQuestionAns?.some(
      (item) => item.confQuesId === insCQ.key && item.confAns
    )
  );

  const siteComplianceHandler = (isChecked, siteComplianceData) => {
    const isCheckedValue = isChecked;
    setSwInspectionSiteCompliance((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) =>
          (item.key || item.itemId) ===
          (siteComplianceData.key || siteComplianceData.itemId)
      );

      if (existingIndex !== -1) {
        const updatedData = [...prevState];

        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          itemId: siteComplianceData?.key,
          siteAns: isCheckedValue,
        };

        return updatedData;
      }

      return prevState;
    });
  };

  useEffect(() => {
    if (
      getSwReference?.SwInspectionAcknowledgement &&
      certifyStatementIdValue
    ) {
      const findInspectionAcknowledgement =
        getSwReference?.SwInspectionAcknowledgement?.find(
          (item) => item.key === certifyStatementIdValue
        );
      setAcknowledgement(
        findInspectionAcknowledgement?.description ||
        findInspectionAcknowledgement?.value
      );
    }
  }, [getSwReference, certifyStatementIdValue]);

   const [swInspectionSiteComplianceChecked, setSwInspectionSiteComplianceChecked] = useState(false);

  useEffect(() => {
    if (swInspectionSiteCompliance) {
      const anyChecked = swInspectionSiteCompliance.some(
        (item) => item.siteAns
      );
      setSwInspectionSiteComplianceChecked(anyChecked);
    }
  }, [swInspectionSiteCompliance]);

  return (
    <div className="swAddReport">
      <Grid container className="formController" mt={5}>
        <Grid container item md={9} xs={12} spacing={2}>
          {!mapId && (
            <SwIndividualCommonForm
              formValue={formValue}
              setFormValue={setFormValue}
              handleAllProjectSearch={handleAllProjectSearch}
              isProjectLoading={isProjectLoading}
              allProjects={allProjects}
              projects={projects}
              onChangeProjects={onChangeProjects}
              getSwReference={getSwReference}
              inspectionQuestionSetList={inspectionQuestionSetList}
              inspectionTypeId={inspectionTypeId}
              handleInspectionTypeSetChange={handleInspectionTypeSetChange}
              questionSetId={questionSetId}
              handleQuestionSetChange={handleQuestionSetChange}
              allClients={allClients}
              clients={clients}
              searchClient={searchClient}
              onChangeClients={onChangeClients}
              isSearchClientLoading={isSearchClientLoading}
              firstClientError={firstClientError}
              frequencyValue={frequencyValue}
              handleFrequencyChange={handleFrequencyChange}
              frequencyInDays={frequencyInDays}
              dateRangeHandler={dateRangeHandler}
              dateRangeError={dateRangeError}
              errorFrequencyInDays={errorFrequencyInDays}
              frequency={frequency}
              // temporary base change
              InspectionType={InspectionType}
              frequencyValueError={frequencyValueError}
              editMode={editMode}
              disabledCheck={disabledCheck}
            />
          )}

          {questionSetId && swQuestionSetDetail && (
            <>
              <SwCommonForm
                formValue={formValue}
                setFormValue={setFormValue}
                getInTyFeByInTyList={getInTyFeByInTyList}
                isProjectName={isProjectName}
                isCustomerName={isCustomerName}
                isProjectNo={isProjectNo}
                isPrimaryInspector={isPrimaryInspector}
                isDateofInspection={isDateofInspection}
                isTimeofInspection={isTimeofInspection}
                isWeatherAtTimeofInspection={isWeatherAtTimeofInspection}
                isSoilTypeId={isSoilTypeId}
                isStageOfConstruction={isStageOfConstruction}
                isSampleTaken={isSampleTaken}
                isPrimaryPermitteeName={isPrimaryPermitteeName}
                isCurrentApproximateDisturbedAcreage={
                  isCurrentApproximateDisturbedAcreage
                }
                isNPDESTrackingNumber={isNPDESTrackingNumber}
                getSwReference={getSwReference}
                listPermitte={listPermitte}
                mapId={mapId}
                inspectionHeaderDetails={inspectionHeaderDetails}
                constructionActivityId={constructionActivityId}
                handleConstructionActivitySetChange={
                  handleConstructionActivitySetChange
                }
                isConstructionActivityId={isConstructionActivityId}
                projectStatus={projectStatus}
                setProjectStatus={setProjectStatus}
                alsoSubmitRoutineInspection={alsoSubmitRoutineInspection}
                handleChangeDefault={handleChangeDefault}
                inspectionTypeId={inspectionTypeId}
                characterLimit={characterLimit}
                isRainFallError={isRainFallError}
                isDirectIns={isDirectIns}
                editMode={editMode}
                frequencyValue={frequencyValue}
                handleFrequencyChange={handleFrequencyChange}
                frequency={frequency}
                frequencyInDays={frequencyInDays}
                dateRangeHandler={dateRangeHandler}
                dateRangeError={dateRangeError}
                errorFrequencyInDays={errorFrequencyInDays}
                frequencyValueError={frequencyValueError}
                disabledCheck={disabledCheck}
                weather={weather}
                swRainFallDataModalData={swRainFallDataModalData}
                isProjectStatus={isProjectStatus}
                userInfo={userInfo}
                isRainfallChecked={isRainfallChecked}
                isSiteAssessment={isSiteAssessment}
                isTnpeNumber={isTnpeNumber}
                isCpescNumber={isCpescNumber}
              />
            </>
          )}
        </Grid>
      </Grid>

      {questionSetId && swQuestionSetDetail && (
        <>
          {isNorthCarolina && (
            <Grid container>
              <Grid item md={12} className="northCarolinaOverride" mt={3}>
                <div className="commonTableBoxNorth">
                  <div className="commonTableBoxNorthTitle">
                    7 Day Rainfall Data
                  </div>
                  <table>
                    <tr className="tableHead">
                      <th>Day/Date </th>
                      <th>Rain Amount (in)</th>
                      <th>Initials</th>
                      <th className="fourty">
                        Notes:
                        <div className="smallText">
                          Daily Rainfall Required. Except for Holidays or
                          Weekends.If no rain, indicate with a “zero”
                        </div>
                      </th>
                    </tr>
                    {swRainFallData?.map((rainFall) => {
                      const onchangeValue = swInspectionRainfallData.find(
                        (item) =>
                          item.precipDateFormat === rainFall.precipDateFormat
                      )?.notes;

                      return (
                        <tr className="tableBody" key={rainFall?.precipId}>
                          <td>{rainFall?.precipDateFormat || rainFall.day}</td>
                          <td>
                            {(
                              Math.floor(rainFall?.evenTrackPrecipAmt * 100) /
                              100
                            )?.toFixed(2)}
                          </td>
                          <td>{initials}</td>
                          <td>
                            <InputField
                              isRequired={false}
                              type="text"
                              placeholder={"Enter Here..."}
                              value={onchangeValue}
                              onChange={(e) =>
                                rainFallHandler(e.target.value, rainFall)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </Grid>
              <Grid item md={12} className="northCarolinaOverride" mt={2}>
                <div className="commonTableBoxNorth">
                  <div className="commonTableBoxNorthTitle">
                    <FormLabels
                      label={"Current Phase of Project"}
                      isRequired={true}
                    />
                  </div>
                  <table>
                    <tr className="tableHead">
                      <th className="sixty">
                        Check ALL applicable box(es) that apply to completed &
                        current phases
                      </th>
                      <th>Status:</th>
                    </tr>
                    {swInspectionCurrentProjectPhase?.map((projectPhase) => {
                      return (
                        <tr className="tableBody" key={projectPhase?.key}>
                          <td className="projectPhaseLeft">
                            <div className="left">
                              {projectPhase?.value || projectPhase?.optionName}
                            </div>
                            <div className="right">
                              <Checkbox
                                checked={projectPhase?.isChecked}
                                onChange={(e) =>
                                  projectPhaseHandler(
                                    e.target.checked,
                                    projectPhase.status,
                                    projectPhase?.comment,
                                    projectPhase
                                  )
                                }
                                label={""}
                              />
                            </div>
                          </td>
                          <td>
                            <SelectMenu
                              listData={CURRENT_PHASE_STATUS}
                              value={projectPhase.status}
                              placeholder="Please Select"
                              onchangehandler={(e) =>
                                projectPhaseHandler(
                                  projectPhase?.isChecked,
                                  e.target.value,
                                  projectPhase?.comment,
                                  projectPhase
                                )
                              }
                            />
                            {projectPhase.status === 3 && (
                              <InputField
                                isRequired={false}
                                type="text"
                                placeholder={"Enter Here..."}
                                value={projectPhase.comment || ""}
                                onChange={(e) =>
                                  projectPhaseHandler(
                                    projectPhase?.isChecked,
                                    projectPhase.status,
                                    e.target.value,
                                    projectPhase
                                  )
                                }
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
                <Grid md={12} item mb={2}>
                  {projectPhaseError && !projectPhaseAnyChecked && (
                    <p className="error">
                      Please select at least one current project phase.
                    </p>
                  )}
                </Grid>
              </Grid>
              <Grid item md={12} className="northCarolinaOverride" mt={2}>
                <div className="twoQuestionBox">
                  {getSwReference?.InsConfQuesList?.slice(2, 4)?.map(
                    (insCQ) => {
                      const selectedAnswer = swInspectionConfQuestionAns?.find(
                        (item) => item.confQuesId === insCQ.key
                      )?.confAns;
                      return (
                        <div className="twoQuestionList" key={insCQ?.key}>
                          <Grid item md={7} xs={12}>
                            <FormControl fullWidth>
                              <FormLabels
                                label={insCQ?.value}
                                isRequired={true}
                              />
                              <SelectMenu
                                placeholder="Please Select"
                                listData={YES_NO ?? []}
                                value={selectedAnswer ?? ""}
                                onchangehandler={(e) =>
                                  twoQuesHandler(e.target.value, insCQ)
                                }
                              />
                            </FormControl>
                          </Grid>
                        </div>
                      );
                    }
                  )}
                  {!allQuestionsAnswered && twoQuestionError && (
                    <Grid item md={12} mb={2}>
                      <p className="error">
                        Please answer all required inspection confirmation
                        questions.
                      </p>
                    </Grid>
                  )}
                </div>
              </Grid>
            </Grid>
          )}

          {isTennessee && (
            <Grid container>
              <Grid item md={12} className="northCarolinaOverride" mt={2}>
                <div className="commonTableBoxNorth">
                  <table>
                    <tr className="tableHead">
                      <th className="sixty">
                        Check the box if the following items are on-site:<span className="error">*</span>
                      </th>
                    </tr>
                    {swInspectionSiteCompliance?.map(
                      (siteCompliance, index) => {
                        const isLastItem =
                          index === swInspectionSiteCompliance.length - 1;

                        return (
                          <tr
                            className="tableBody"
                            key={siteCompliance?.key || siteCompliance?.itemId}
                          >
                            <td className="projectPhaseLeft">
                              <div className="left">
                                {siteCompliance?.value ||
                                  siteCompliance?.optionName}
                              </div>
                              <div className="right">
                                {isLastItem ? (
                                  <InputField
                                    isRequired={false}
                                    type="text"
                                    placeholder={"Western side entry"}
                                    value={siteCompliance?.siteComment || ""}
                                    onChange={(e) => {
                                      const updatedValue = e.target.value;
                                      setSwInspectionSiteCompliance(
                                        (prevState) => {
                                          const updatedState = [...prevState];
                                          updatedState[index] = {
                                            ...updatedState[index],
                                            siteComment: updatedValue,
                                          };
                                          return updatedState;
                                        }
                                      );
                                    }}
                                  />
                                ) : (
                                  <Checkbox
                                    checked={siteCompliance?.siteAns}
                                    onChange={(e) =>
                                      siteComplianceHandler(
                                        e.target.checked,
                                        siteCompliance
                                      )
                                    }
                                    label={""}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </table>
                </div>
              </Grid>
              <Grid md={12} item mb={2}>
                {siteComplianceError && !swInspectionSiteComplianceChecked && (
                  <p className="error">
                    Please select at least one Checkbox.
                  </p>
                )}
              </Grid>
            </Grid>
          )}

          <Grid container justifyContent={"right"}>
            <Buttons
              varientContained={true}
              label={allExpanded ? "Collapse All" : "Expand All"}
              onClick={() => {
                setaccordionLoader(true);
                setallExpanded(!allExpanded);
                setTimeout(() => {
                  setaccordionLoader(false);
                }, 300);
              }}
            // disabled={isSubmit ? true : false}
            />
          </Grid>
          {accordionLoader ? (
            <Loader />
          ) : (
            <Grid mt={5}>
              <div>
                {swQuestionSetDetail?.map((category, categoryIndex) => (
                  <>
                    <Accordion
                      key={categoryIndex}
                      className="swAccordianParent"
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        className="swAccordian"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <div className="cateTitleWIns">
                          <Typography className="accoTitle">
                            {category.value}
                          </Typography>

                          <div className="catButtonBox">
                            <div className="cats">
                              {previousItem?.some((prevItem) =>
                                category?.listInspectionSubCategory?.some(
                                  (subCategory) =>
                                    subCategory.listInspectionQuestionAnswer?.some(
                                      (item) =>
                                        previousItem.some(
                                          (secItem) =>
                                            parseInt(prevItem.questionId) ===
                                            parseInt(item.key) ||
                                            parseInt(secItem.questionId) ===
                                            parseInt(item.key)
                                        )
                                    )
                                )
                              ) ? (
                                <>
                                  <div className="openInfoContainer">
                                    <div className="openInfoInfo">
                                      <img
                                        src={commonImages?.RedInfo}
                                        alt=""
                                        className=""
                                      />
                                      <div className="openInfoMsg">
                                        There are some Open items in categories
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="inspectPersantage">
                              {category.howManyCat}/
                              {category.listInspectionSubCategory?.length}{" "}
                              Inspected ({category.catPercent?.toFixed(2)}%)
                            </div>
                          </div>
                        </div>
                      </AccordionSummary>

                      <AccordionDetails>
                        {category.listInspectionSubCategory.map(
                          (subcategory, subcategoryIndex) => (
                            <>
                              <Accordion
                                key={subcategoryIndex}
                                className="swAccordianChild"
                                defaultExpanded={allExpanded}
                                onChange={() =>
                                  handleAccordionExpand(subcategory.value)
                                }
                                expanded={
                                  expandedItems?.includes(subcategory.value) ||
                                  allExpanded
                                }
                              >
                                <AccordionSummary
                                  className="swChildAccordian"
                                  expandIcon={<ExpandMoreIcon />}
                                >
                                  <div className="subCatButton">
                                    <Typography className="accoTitle">
                                      {subcategory.value}
                                    </Typography>
                                    <div className="subCatButtonBox">
                                      <div>
                                        {previousItem?.some((prevItem) =>
                                          subcategory?.listInspectionQuestionAnswer?.some(
                                            (item) =>
                                              prevItem.questionId === item.key
                                          )
                                        ) ? (
                                          <div className="openInfoContainer">
                                            <div className="openInfoInfo">
                                              <img
                                                src={commonImages?.RedInfo}
                                                alt=""
                                                className=""
                                              />
                                              <div className="openInfoMsg">
                                                There are some Open items in
                                                sub-categories
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      <div className="inspectPersantage">
                                        {subcategory.howManySub}/
                                        {
                                          subcategory
                                            .listInspectionQuestionAnswer.length
                                        }{" "}
                                        Inspected (
                                        {subcategory.subPercent?.toFixed(2)}
                                        %)
                                      </div>
                                    </div>
                                  </div>

                                  {subcategory?.listInspectionQuestionAnswer?.some(
                                    (x) => x.isTextResponse
                                  ) ||
                                    previousItem?.some((prevItem) =>
                                      subcategory?.listInspectionQuestionAnswer?.some(
                                        (item) => prevItem.questionId === item.key
                                      )
                                    ) ? (
                                    ""
                                  ) : (
                                    <div className="posChange">
                                      {(subcategory?.showBth && allExpanded) ||
                                        (subcategory?.showBth &&
                                          expandedItems.includes(
                                            subcategory.value
                                          )) ? (
                                        <div className="subCatButtonBox">
                                          <div
                                            className="allacceptbleBtn"
                                            onClick={(e) =>
                                              handleRadioType(
                                                null,
                                                null,
                                                subcategory,
                                                category,
                                                "allAcceptable",
                                                e
                                              )
                                            }
                                          >
                                            All Acceptable
                                          </div>

                                          <div
                                            className="allNotapplicableBtn"
                                            onClick={(e) =>
                                              handleRadioType(
                                                null,
                                                null,
                                                subcategory,
                                                category,
                                                "notApplicable",
                                                e
                                              )
                                            }
                                          >
                                            All N/A
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  )}
                                </AccordionSummary>

                                <AccordionDetails>
                                  <ul>
                                    {subcategory.listInspectionQuestionAnswer.map(
                                      (question, questionIndex) => (
                                        <>
                                          <li
                                            key={questionIndex}
                                            className="accordianQuestionBox"
                                          >
                                            <div className="quesTitle">
                                              {question.quesNo}
                                              {". "}
                                              {question.value}
                                            </div>
                                            {question?.responseType === 2 ? (
                                              <div className="questionFreeText">
                                                <TextEditor
                                                  value={
                                                    question?.textValueQuestion
                                                  }
                                                  placeholder={"Enter Here..."}
                                                  name="freeText"
                                                  onChange={(e) =>
                                                    handleRadioType(
                                                      e,
                                                      question,
                                                      subcategory,
                                                      category,
                                                      "questionV"
                                                    )
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              <>
                                                <div>
                                                  <div className="radioContainer">
                                                    <RadioGroup
                                                      row
                                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                                      name="row-radio-buttons-group"
                                                      className="radioGroup"
                                                    >
                                                      <RadioButton
                                                        checked={
                                                          question.radioSelectiovalue ==
                                                          "1"
                                                        }
                                                        value={"1"}
                                                        label="Acceptable"
                                                        onChange={(e) =>
                                                          handleRadioType(
                                                            e.target.value,
                                                            question,
                                                            subcategory,
                                                            category,
                                                            "radio"
                                                          )
                                                        }
                                                        disabled={
                                                          previousItem?.length >
                                                          0 &&
                                                          previousItem?.some(
                                                            (x) =>
                                                              x.questionId ===
                                                              question.key
                                                          )
                                                        }
                                                      ></RadioButton>

                                                      <RadioButton
                                                        checked={
                                                          question.radioSelectiovalue ==
                                                          "2"
                                                        }
                                                        value={"2"}
                                                        label="Not Acceptable"
                                                        onChange={(e) =>
                                                          handleRadioType(
                                                            e.target.value,
                                                            question,
                                                            subcategory,
                                                            category,
                                                            "radio"
                                                          )
                                                        }
                                                      ></RadioButton>
                                                      <RadioButton
                                                        checked={
                                                          question.radioSelectiovalue ==
                                                          3
                                                        }
                                                        value={3}
                                                        label="N/A"
                                                        onChange={(e) =>
                                                          handleRadioType(
                                                            e.target.value,
                                                            question,
                                                            subcategory,
                                                            category,
                                                            "radio"
                                                          )
                                                        }
                                                        disabled={
                                                          previousItem?.length >
                                                          0 &&
                                                          previousItem?.some(
                                                            (x) =>
                                                              x.questionId ===
                                                              question.key
                                                          )
                                                        }
                                                      ></RadioButton>
                                                    </RadioGroup>
                                                  </div>
                                                  {/* {(question.radioSelectiovalue ==
                                                  "1" ||
                                                  question.radioSelectiovalue ==
                                                    "3") &&
                                                question.responseType === 3 ? (
                                                  <>
                                                    <div className="radioContainer">
                                                      <ThreeQuestion
                                                        formchangeThreeHnadle={
                                                          formchangeThreeHnadle
                                                        }
                                                        question={question}
                                                        subcategory={
                                                          subcategory
                                                        }
                                                        category={category}
                                                      />
                                                    </div>
                                                  </>
                                                ) : (
                                                  ""
                                                )} */}

                                                  {question.radioSelectiovalue ==
                                                    "2" ? (
                                                    <>
                                                      {question
                                                        .notAcceptableList
                                                        ?.length !== 0 &&
                                                        question.notAcceptableList?.map(
                                                          (
                                                            notAppce,
                                                            notAppceIndex
                                                          ) => {
                                                            return (
                                                              <>
                                                                <Grid
                                                                  container
                                                                  className="itemContainer"
                                                                  key={
                                                                    notAppceIndex
                                                                  }
                                                                >
                                                                  <Grid
                                                                    md={12}
                                                                    xs={12}
                                                                    item
                                                                    mt={1}
                                                                  >
                                                                    <div
                                                                      onClick={() =>
                                                                        deleteform(
                                                                          notAppce?.id,
                                                                          question,
                                                                          subcategory,
                                                                          category,
                                                                          "deleteItem"
                                                                        )
                                                                      }
                                                                      className="removeRepetBox"
                                                                    >
                                                                      X Remove
                                                                      Items
                                                                    </div>

                                                                    <FormControl
                                                                      fullWidth
                                                                    >
                                                                      <FormLabels
                                                                        label="Item Found"
                                                                        isRequired={
                                                                          true
                                                                        }
                                                                      />
                                                                      <SelectMenu
                                                                        placeholder="Please Select"
                                                                        listData={
                                                                          question?.options ??
                                                                          []
                                                                        }
                                                                        value={
                                                                          notAppce?.itemFoundKey ??
                                                                          null
                                                                        }
                                                                        onchangehandler={(
                                                                          e
                                                                        ) =>
                                                                          formchangeHnadle(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            question,
                                                                            subcategory,
                                                                            category,
                                                                            "itemFound",
                                                                            notAppce
                                                                          )
                                                                        }
                                                                      />
                                                                    </FormControl>
                                                                    {notAppce?.itemFoundError && (
                                                                      <div className="error">
                                                                        Please
                                                                        select
                                                                        this
                                                                        required
                                                                        field.
                                                                      </div>
                                                                    )}
                                                                  </Grid>
                                                                  {/* {question?.itemFound} */}
                                                                  {notAppce?.itemFoundValue ===
                                                                    "Other" && (
                                                                      <Grid
                                                                        md={12}
                                                                        xs={12}
                                                                        item
                                                                        mt={2}
                                                                      >
                                                                        <FormLabels label="Item Details" />

                                                                        <TextEditor
                                                                          value={
                                                                            notAppce?.itemDetails
                                                                          }
                                                                          placeholder={
                                                                            "Enter Here..."
                                                                          }
                                                                          name="freeText"
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            formchangeHnadle(
                                                                              e,
                                                                              question,
                                                                              subcategory,
                                                                              category,
                                                                              "textArea",
                                                                              notAppce
                                                                            )
                                                                          }
                                                                        />
                                                                      </Grid>
                                                                    )}

                                                                  <Grid
                                                                    md={12}
                                                                    xs={12}
                                                                    item
                                                                    mt={2}
                                                                  >
                                                                    <div className="locationContainer">
                                                                      <FormControl
                                                                        fullWidth
                                                                      >
                                                                        <FormLabels
                                                                          label="Add Location Details"
                                                                          isRequired={
                                                                            true
                                                                          }
                                                                        />
                                                                      </FormControl>
                                                                      <div className="locationInput">
                                                                        <Grid
                                                                          container
                                                                          className="locationInputBox"
                                                                        >
                                                                          <Grid
                                                                            md={
                                                                              5
                                                                            }
                                                                            xs={
                                                                              12
                                                                            }
                                                                            item
                                                                          >
                                                                            <FormControl
                                                                              fullWidth
                                                                              className="mediaInputContainer"
                                                                            >
                                                                              <InputField
                                                                                fullWidth={
                                                                                  true
                                                                                }
                                                                                type="text"
                                                                                value={
                                                                                  notAppce?.addLocationText
                                                                                }
                                                                                onChange={(
                                                                                  e
                                                                                ) =>
                                                                                  formchangeHnadle(
                                                                                    e
                                                                                      .target
                                                                                      .value,
                                                                                    question,
                                                                                    subcategory,
                                                                                    category,
                                                                                    "textFiled",
                                                                                    notAppce
                                                                                  )
                                                                                }
                                                                                placeholder={
                                                                                  "Enter Text Here..."
                                                                                }
                                                                                className="locationInputText"
                                                                              />
                                                                            </FormControl>
                                                                          </Grid>
                                                                          <Grid
                                                                            md={
                                                                              5
                                                                            }
                                                                            xs={
                                                                              12
                                                                            }
                                                                            item
                                                                            className="addLocationCustomButton"
                                                                          >
                                                                            <Buttons
                                                                              aria-describedby="dd"
                                                                              variant="contained"
                                                                              type="button"
                                                                              name="btn"
                                                                              label={
                                                                                "Add Location"
                                                                              }
                                                                              onClick={(
                                                                                e
                                                                              ) =>
                                                                                formchangeHnadle(
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                  question,
                                                                                  subcategory,
                                                                                  category,
                                                                                  "pushData",
                                                                                  notAppce
                                                                                )
                                                                              }
                                                                              id="btnAddEquipment"
                                                                              varientAddIconBlue={
                                                                                true
                                                                              }
                                                                            ></Buttons>
                                                                          </Grid>
                                                                        </Grid>
                                                                      </div>

                                                                      {notAppce?.addLocatioList?.map(
                                                                        (
                                                                          noteee,
                                                                          noteeeIndex
                                                                        ) => {
                                                                          return (
                                                                            <Grid
                                                                              container
                                                                              key={
                                                                                noteee?.id
                                                                              }
                                                                            >
                                                                              <Grid
                                                                                md={
                                                                                  7
                                                                                }
                                                                                xs={
                                                                                  12
                                                                                }
                                                                                item
                                                                              >
                                                                                <div className="locationListBox">
                                                                                  <div className="locationList">
                                                                                    {noteee.textVaue ? (
                                                                                      <>
                                                                                        <div className="locationTitile">
                                                                                          <span>
                                                                                            {
                                                                                              noteee.textVaue
                                                                                            }
                                                                                          </span>
                                                                                          <div
                                                                                            className="removeImg"
                                                                                            onClick={() =>
                                                                                              deleteHandler(
                                                                                                category,
                                                                                                subcategory,
                                                                                                question,
                                                                                                notAppce,
                                                                                                noteee,
                                                                                                "deleteText"
                                                                                              )
                                                                                            }
                                                                                          >
                                                                                            x
                                                                                          </div>
                                                                                        </div>
                                                                                        {noteee?.imgUrl && (
                                                                                          <div className="locationImg">
                                                                                            <img
                                                                                              alt=""
                                                                                              src={
                                                                                                noteee?.imgUrl
                                                                                              }
                                                                                              className="showUploadedImg"
                                                                                            />
                                                                                            <div
                                                                                              className="removeImg"
                                                                                              onClick={() =>
                                                                                                deleteHandler(
                                                                                                  category,
                                                                                                  subcategory,
                                                                                                  question,
                                                                                                  notAppce,
                                                                                                  noteee,
                                                                                                  "deleteImg"
                                                                                                )
                                                                                              }
                                                                                            >
                                                                                              x
                                                                                            </div>
                                                                                          </div>
                                                                                        )}
                                                                                        {isMediaAllowed &&
                                                                                          !noteee?.imgUrl && (
                                                                                            <div className="addMedia">
                                                                                              <input
                                                                                                type="file"
                                                                                                ref={(
                                                                                                  el
                                                                                                ) =>
                                                                                                (hiddenAttendeeSignatureInput.current[
                                                                                                  noteee?.id
                                                                                                ] =
                                                                                                  el)
                                                                                                }
                                                                                                onChange={(
                                                                                                  event
                                                                                                ) => {
                                                                                                  addMediaNotAccUpload(
                                                                                                    event,
                                                                                                    question,
                                                                                                    subcategory,
                                                                                                    category,
                                                                                                    notAppce,
                                                                                                    noteee
                                                                                                  );
                                                                                                }}
                                                                                                style={{
                                                                                                  display:
                                                                                                    "none",
                                                                                                }}
                                                                                                accept="image/*"
                                                                                              />
                                                                                              <div
                                                                                                className="multipleIconContainer"
                                                                                                onClick={() => {
                                                                                                  hiddenAttendeeSignatureInput.current[
                                                                                                    noteee
                                                                                                      ?.id
                                                                                                  ].click();
                                                                                                  setImageCheck(
                                                                                                    false
                                                                                                  );
                                                                                                }}
                                                                                              >
                                                                                                <div className="multipleIconImg">
                                                                                                  <img
                                                                                                    src={
                                                                                                      mode ===
                                                                                                        "dark"
                                                                                                        ? commonImages.multipleMediaDark
                                                                                                        : commonImages?.multipleMedia
                                                                                                    }
                                                                                                    alt="icon"
                                                                                                  />
                                                                                                </div>
                                                                                                <div>
                                                                                                  Upload
                                                                                                  Media
                                                                                                </div>
                                                                                              </div>
                                                                                            </div>
                                                                                          )}
                                                                                      </>
                                                                                    ) : null}
                                                                                  </div>
                                                                                  {noteee?.uniqeFileErrorMessage &&
                                                                                    !noteee?.imgUrl && (
                                                                                      <Grid
                                                                                        className="error"
                                                                                        mt={
                                                                                          1
                                                                                        }
                                                                                      >
                                                                                        {
                                                                                          fileError
                                                                                        }
                                                                                      </Grid>
                                                                                    )}
                                                                                </div>
                                                                              </Grid>
                                                                            </Grid>
                                                                          );
                                                                        }
                                                                      )}
                                                                    </div>
                                                                    {notAppce?.addLocationDetailError && (
                                                                      <div className="error">
                                                                        Please
                                                                        select
                                                                        this
                                                                        required
                                                                        field.
                                                                      </div>
                                                                    )}
                                                                  </Grid>
                                                                </Grid>
                                                              </>
                                                            );
                                                          }
                                                        )}

                                                      <Grid className="buttonConttainer">
                                                        <Buttons
                                                          aria-describedby="dd"
                                                          variant="variantOutlineBorder"
                                                          type="button"
                                                          name="btn"
                                                          label={"Add Item"}
                                                          id="btnAddEquipment"
                                                          variantOutlineBorder={
                                                            true
                                                          }
                                                          onClick={(e) =>
                                                            handleRadioType(
                                                              null,
                                                              question,
                                                              subcategory,
                                                              category,
                                                              "appendFrom"
                                                            )
                                                          }
                                                        ></Buttons>
                                                        {/* {question?.responseType ===
                                                        3 && (
                                                        <ThreeQuestion
                                                          formchangeThreeHnadle={
                                                            formchangeThreeHnadle
                                                          }
                                                          question={question}
                                                          subcategory={
                                                            subcategory
                                                          }
                                                          category={category}
                                                        />
                                                      )} */}
                                                      </Grid>
                                                    </>
                                                  ) : null}
                                                </div>
                                              </>
                                            )}
                                          </li>
                                          {/* {previousItem?.length > 0 ? ( */}
                                          <>
                                            {" "}
                                            <PreviousOpenItems
                                              openItemHandler={openItemHandler}
                                              previousItem={
                                                previousItem
                                                  ? previousItem?.filter(
                                                    (x) =>
                                                      x.questionId ===
                                                      question.key &&
                                                      x.inspectionId !==
                                                      reportId
                                                  )
                                                  : []
                                              }
                                              getSwReference={getSwReference}
                                            />{" "}
                                          </>
                                          {/* ) : (
                                      getOpenItem(question)
                                    )} */}
                                        </>
                                      )
                                    )}
                                  </ul>
                                </AccordionDetails>
                              </Accordion>
                              {subcategory?.subCatError &&
                                subcategory.listInspectionQuestionAnswer?.some(
                                  (item) =>
                                    parseInt(item?.responseType) === 2
                                      ? !item.textValueQuestion
                                      : !item.radioSelectiovalue
                                ) ? (
                                <p className="error mb-10">
                                  All Question are required.
                                </p>
                              ) : null}
                            </>
                          )
                        )}
                      </AccordionDetails>
                    </Accordion>
                    <div>
                      {category.catError && !category?.catAns ? (
                        <p className="error mb-10">
                          All Question are required.
                        </p>
                      ) : null}
                    </div>
                  </>
                ))}
              </div>
            </Grid>
          )}
          {isSouthCarolina && (
            <Grid container>
              <SouthCarolina swInspectionNPDES={swInspectionNPDES} setSwInspectionNPDES={setSwInspectionNPDES} />
            </Grid>
          )}
          {isNorthCarolina && (
            <Grid container>
              <NorthCarolina
                userInfo={userInfo}
                swRainFallData={swRainFallData}
                getSwReference={getSwReference}
                swInspectionConfQuestionAns={swInspectionConfQuestionAns}
                setSwInspectionConfQuestionAns={setSwInspectionConfQuestionAns}
                swInspectionRainfallData={swInspectionRainfallData}
                swInspectionCurrentProjectPhase={
                  swInspectionCurrentProjectPhase
                }
                setSwInspectionCurrentProjectPhase={
                  setSwInspectionCurrentProjectPhase
                }
                swInspectionGroundStabilization={
                  swInspectionGroundStabilization
                }
                setSwInspectionGroundStabilization={
                  setSwInspectionGroundStabilization
                }
                swInspectionObservation={swInspectionObservation}
                setSwInspectionObservation={setSwInspectionObservation}
                swInspectionLotDisturbance={swInspectionLotDisturbance}
                setSwInspectionLotDisturbance={setSwInspectionLotDisturbance}
                setSwInspectionNewOrRevisedMeasures={
                  setSwInspectionNewOrRevisedMeasures
                }
                swInspectionNewOrRevisedMeasures={
                  swInspectionNewOrRevisedMeasures
                }
                twoQuestionError={twoQuestionError}
              />
            </Grid>
          )}
          <Grid container>
            {(parseInt(signoffMethodValue) ===
              SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
              parseInt(signoffMethodValue) === 4) && (
                <Grid item md={12} xs={12} my={5}>
                  <p className="defaultMsg">{acknowledgement}</p>
                </Grid>
              )}

            {(parseInt(signoffMethodValue) === SIGNOFF_METHOD_TYPE.SIGNATURE ||
              parseInt(signoffMethodValue) === 4) && (
                <>
                  {!isSignatureProfile && (
                    <Grid item md={12} xs={12}>
                      <FormLabels label="Add Inspector’s Signature" />

                      <input
                        type="file"
                        ref={hiddenSignatureInput}
                        onChange={(event) => {
                          contractorsignatureUpload(event);
                        }}
                        style={{ display: "none" }}
                        accept="image/*"
                      />
                      <label
                        className="signatureBtn"
                        onClick={() => {
                          hiddenSignatureInput.current.click();
                          setImageCheck(true);
                        }}
                        htmlFor="actual-btn"
                      >
                        <AddIcon /> Add Signature
                      </label>
                    </Grid>
                  )}

                  {signaureFileError && (
                    <div className="error">{signaureFileErrorMessage}</div>
                  )}

                  <Grid item lg={12} xs={12} mt={1}>
                    {!selectedContractorSignature && signatureError && (
                      <p className="error">Please Add Signature</p>
                    )}
                  </Grid>

                  <Grid item container mt={0} className="topHeaderProfile">
                    <Grid item lg={6} xs={12} mt={2}>
                      <Grid className="signatureImg">
                        {isSignatureProfile ? (
                          <img
                            className="borderSignatureImg"
                            src={isSignatureProfile}
                            alt=""
                          />
                        ) : (
                          <>
                            {selectedContractorSignature && (
                              <img
                                className="borderSignatureImg"
                                src={selectedContractorSignature}
                                alt=""
                              />
                            )}
                          </>
                        )}
                        {isSignatureProfile && (
                          <div className="overideLables">
                            <div className="formLabel">Authorized signature</div>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
          </Grid>

          <Grid container mt={7} className="buttonEnd">
            <Grid item lg={4} xs={12} sm={6} md={6}>
              <Buttons
                varientText={true}
                label="Save As Draft"
                onClick={saveData}
              />
            </Grid>
            <Grid item lg={4} xs={12} sm={6} md={6}>
              <Buttons
                varientContained={true}
                label={"Save"}
                onClick={submitData}
              // disabled={isSubmit ? true : false}
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default AddReport;
